export default __webpack_public_path__ + "static/media/trend_arrow.8cc3f927.svg";